// https://fkhadra.github.io/react-toastify/
import { Slide, toast as toastFn, ToastContainer as ToastContainerOriginal } from "react-toastify";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";

export const toast = Object.assign(
    (message, options = {}) => toastFn(message, options),
    {
        dismiss: toastFn.dismiss,
        error:   (message, options = {}) => toastFn.error(message, { icon: false, autoClose: false, ...options }),
        info:    (message, options = {}) => toastFn.info(message, { icon: false, ...options }),
        success: (message, options = {}) => toastFn.success(message, { icon: false, ...options }),
        TYPE:    toastFn.TYPE,
        update:  toastFn.update,
        warning: (message, options = {}) => toastFn.warn(message, { icon: false, style: { backgroundColor: "#fff4da", color: "#614b1a" }, ...options })
    }
);

function CloseToast({ closeToast }) {
    return (
        <span className="toast-close-button" onClick={closeToast}>
            <FontAwesomeIcon icon={faTimes}/>
        </span>
    );
}

export function ToastContainer() {
    return (
        <ToastContainerOriginal
            position="top-center"
            transition={Slide}
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            // pauseOnVisibilityChange
            theme="colored"
            draggable
            pauseOnHover
            closeButton={<CloseToast />}
        />
    );
}

export { useNotificationCenter } from "react-toastify/addons/use-notification-center";
